import Phaser from "phaser"
import { calculateScaleFactor } from "../config/scaling"
import {
	checkLocalSavedData,
	handleGameProgressUpdate,
	displayTooltip,
	destroyInstructions,
	destroyTooltip,
	destroyIndicator,
	playUISound,
	animateElements,
} from "../helpers/levelManager"
import { MediclinicAPI } from "../helpers/apiHandler"

import { displayIndicator } from "../helpers/levelManager"
import { displayInstructions } from "../helpers/levelManager"
import { updateMiniLevel } from "../helpers/levelManager"
import {
	saveCreatureStatusLocally,
	createStoryPanel,
} from "../helpers/levelManager"
export default class CertificatePresentation extends Phaser.Scene {
	constructor() {
		super({ key: "CertificatePresentation" })
		this.currentPage = 0
		this.totalPages = 4
		this.canClickBool = true
	}

	init() {
		this.initializeGameDimensions()
		this.loadSavedData()

		this.apiHandler = new MediclinicAPI()
	}

	initializeGameDimensions() {
		this.gameW = this.cameras.main.width
		this.gameH = this.cameras.main.height

		const scalingData = calculateScaleFactor(this)
		this.scaleFactor = scalingData.scaleFactor
		this.safeZoneX = scalingData.safeZoneX
		this.safeZoneY = scalingData.safeZoneY
		this.safeZoneWidth = scalingData.safeZoneWidth
		this.safeZoneHeight = scalingData.safeZoneHeight

		// Responsive font sizing
		this.baseFontSize = 20
		this.fontSize = this.baseFontSize * this.scaleFactor

		this.fontColor = "#11044E"
	}

	loadSavedData() {
		this.savedUserData = checkLocalSavedData()
		this.savedLevel = this.savedUserData?.userLevel || 0
		this.savedOrnament = this.savedUserData?.customization?.ornament || 0
		this.savedMiniLevel = this.savedUserData?.userMiniLevel || 0
		this.currentPlanet = this.savedUserData?.currentPlanet || 1
		this.userID = this.savedUserData?.userID || "guest"
		console.log("MiniLevel: " + this.savedMiniLevel)
	}

	create() {
		this.soundManager = this.scene.get("GameUI").soundManager
		this.createBackground()
		this.createStoryBackground()

		// State tracking for the flow
		this.currentScreen = "mission-complete"

		// Mission complete screen elements container
		this.missionCompleteContainer = this.add.container(0, 0)

		// Rating screen elements container
		this.ratingContainer = this.add.container(0, 0)
		this.ratingContainer.setVisible(false)

		// Name input screen elements container
		this.nameInputContainer = this.add.container(0, 0)
		this.nameInputContainer.setVisible(false)

		// Certificate screen elements container
		this.certificateContainer = this.add.container(0, 0)
		this.certificateContainer.setVisible(false)

		// Create the mission complete screen (initial screen)
		this.createMissionComplete()
	}

	createMissionComplete() {
		// Mission Complete Title
		this.missionTitle = this.add
			.text(
				this.gameW / 2,
				this.storyBG.y - 100 * this.scaleFactor,
				"Mission Complete",
				{
					fontSize: Math.round(this.fontSize + 11 * this.scaleFactor) + "px",
					fill: "#11044E",
					fontFamily: '"Gluten", sans-serif',
					fontWeight: "600",
					fontStyle: "bold",
					resolution: 2,
					align: "center",
				},
			)
			.setOrigin(0.5)
		//this.missionCompleteContainer.add(this.missionTitle)

		// First paragraph
		this.missionText = this.add
			.text(
				this.gameW / 2,
				this.missionTitle.y + 50 * this.scaleFactor,
				"You finished all 3 planets. Great work, Medinaut!",
				{
					fontSize: Math.round(this.fontSize - 4 * this.scaleFactor) + "px",
					fill: "#11044E",
					fontFamily: '"Space Grotesk", sans-serif',
					fontWeight: "700",
					fontStyle: "bold",
					resolution: 2,
					align: "center",
				},
			)
			.setOrigin(0.5)
		//this.missionCompleteContainer.add(this.missionText)

		// Second paragraph
		this.missionText02 = this.add
			.text(
				this.gameW / 2,
				this.missionText.y + 40 * this.scaleFactor,
				"Stay tuned for more planets to explore!",
				{
					fontSize: Math.round(this.fontSize - 4 * this.scaleFactor) + "px",
					fill: "#11044E",
					fontFamily: '"Space Grotesk", sans-serif',
					fontWeight: "700",
					resolution: 2,
					align: "center",
					wordWrap: { width: this.safeZoneWidth * 0.7 },
				},
			)
			.setOrigin(0.5)
		//this.missionCompleteContainer.add(this.missionText02)

		// Finish button
		this.finishButton = this.add
			.image(
				this.gameW / 2,
				this.storyBG.y + 75 * this.scaleFactor,
				"activeButton",
			)
			.setScale(this.scaleFactor * 0.5, this.scaleFactor * 0.4)
			.setInteractive({ useHandCursor: true })
			.on("pointerdown", () => {
				playUISound(this, this.soundManager, "Subtle click 1", 0.25)
				console.log("Transitioning to rating screen")
				this.showRatingScreen()
			})
		//this.missionCompleteContainer.add(this.finishButton)

		// Finish button text
		this.finishButtonText = this.add
			.text(
				this.finishButton.x -
				(this.finishButton.width / 4) * this.scaleFactor +
				20 * this.scaleFactor,
				this.finishButton.y - 25 * this.scaleFactor,
				"FINISH",
				{
					fontSize: Math.round(this.fontSize + 8 * this.scaleFactor) + "px",
					fill: "#fff",
					fontFamily: '"Gluten", sans-serif',
					fontWeight: "700",
					fontStyle: "bold",
					resolution: 2,
				},
			)
			.setOrigin(0)
		//this.missionCompleteContainer.add(this.finishButtonText)

		animateElements([this.storyBG, this.missionTitle, this.missionText, this.missionText02, this.finishButton, this.finishButtonText], this)
	}

	showRatingScreen() {
		// Hide mission complete screen
		this.missionCompleteContainer.setVisible(false)
		this.missionTitle.setVisible(false)
		this.missionText.setVisible(false)
		this.missionText02.setVisible(false)
		this.finishButton.setVisible(false)
		this.finishButtonText.setVisible(false)

		// Create and show rating screen if it doesn't exist yet
		if (this.ratingContainer.length === 0) {
			this.createRatingScreen()
		}

		// Show rating screen
		this.ratingContainer.setVisible(true)

		// Update current screen state
		this.currentScreen = "rating"

		animateElements([this.storyBG, this.storyTitle, this.storyText, this.starContainer, this.nextButton, this.nextButtonText], this)
	}

	createRatingScreen() {
		// Thanks for Playing Title
		this.storyTitle = this.add
			.text(
				this.storyBG.x,
				this.storyBG.y - 100 * this.scaleFactor,
				"Thanks For Playing!",
				{
					fontSize: Math.round(this.fontSize + 8 * this.scaleFactor) + "px",
					fill: "#11044E",
					fontFamily: '"Gluten", sans-serif',
					fontWeight: "600",
					fontStyle: "bold",
					resolution: 2,
					align: "center",
				},
			)
			.setOrigin(0.5, 0.5)
		this.ratingContainer.add(this.storyTitle)

		// Rating question text
		this.storyText = this.add
			.text(
				this.storyBG.x,
				this.storyTitle.y + 40 * this.scaleFactor,
				"How did you find the game?",
				{
					fontSize: Math.round(this.fontSize - 3 * this.scaleFactor) + "px",
					fill: "#11044E",
					fontFamily: '"Space Grotesk", sans-serif',
					fontWeight: "400",
					resolution: 2,
					align: "center",
				},
			)
			.setOrigin(0.5, 0.5)
		this.ratingContainer.add(this.storyText)

		// Add Star Rating
		this.createRatingSystem(this.storyText.y + 60 * this.scaleFactor)

		// Create Next Button
		this.createNextButton(this.storyBG.y + 100 * this.scaleFactor)

		// Page indicators
		this.pageIndicator01 = this.add
			.image(
				this.storyBG.x - 10 * this.scaleFactor,
				this.storyBG.y + 160 * this.scaleFactor,
				"activePageIndicator",
			)
			.setScale(this.scaleFactor * 0.65)
		this.ratingContainer.add(this.pageIndicator01)

		this.pageIndicator02 = this.add
			.image(
				this.pageIndicator01.x + 30 * this.scaleFactor,
				this.pageIndicator01.y,
				"inactivePageIndicator",
			)
			.setScale(this.scaleFactor * 0.65)
		this.ratingContainer.add(this.pageIndicator02)
	}

	createRatingSystem(yPosition) {
		// Initialize rating value
		this.currentRating = 0

		this.starContainer = this.add.container(this.storyBG.x, yPosition)
		this.ratingContainer.add(this.starContainer)

		// Create 5 stars
		this.stars = []
		const starCount = 5
		const starSpacing = 80 * this.scaleFactor
		const totalWidth = (starCount - 1) * starSpacing
		const startX = -totalWidth / 2

		for (let i = 0; i < starCount; i++) {
			// Create a star (initially empty)
			const star = this.add
				.image(startX + i * starSpacing, 0, "emptyStar")
				.setScale(this.scaleFactor * 0.3)

			// Make the star interactive
			star.setInteractive({ useHandCursor: true })

			// Add hover effect
			star.on("pointerover", () => {
				this.updateStars(i + 1, true) // Preview rating
			})

			// Reset on pointer out if not clicked
			star.on("pointerout", () => {
				this.updateStars(this.currentRating, false) // Reset to current rating
			})

			// Set rating on click
			star.on("pointerdown", () => {
				playUISound(this, this.soundManager, "Subtle click 1", 0.25)
				this.currentRating = i + 1
				this.updateStars(this.currentRating, false)
			})

			// Add to stars array
			this.stars.push(star)

			// Add to container
			this.starContainer.add(star)
		}
	}

	updateStars(rating, isHover) {
		// Update star appearance based on the rating
		for (let i = 0; i < this.stars.length; i++) {
			if (i < rating) {
				// Fill stars up to the rating
				this.stars[i].setTexture("filledStar")

				// Add slight bounce effect if it's a new selection (not hover)
				if (!isHover && i === rating - 1) {
					this.tweens.add({
						targets: this.stars[i],
						scale: this.scaleFactor * 0.35,
						duration: 200,
						yoyo: true,
						ease: "Back.easeOut",
						onComplete: () => {
							this.stars[i].setScale(this.scaleFactor * 0.3)
						},
					})
				}
			} else {
				// Leave remaining stars empty
				this.stars[i].setTexture("emptyStar")
			}
		}
	}

	createNextButton(yPosition) {
		// Create Next button
		this.nextButton = this.add
			.image(
				this.storyBG.x +
				(this.storyBG.width / 2) * this.scaleFactor -
				30 * this.scaleFactor,
				this.storyBG.y + 75 * this.scaleFactor,
				"activeButton",
			)
			.setScale(this.scaleFactor * 0.5, this.scaleFactor * 0.4)
		this.ratingContainer.add(this.nextButton)

		this.nextButtonText = this.add
			.text(
				this.nextButton.x -
				(this.nextButton.width / 4) * this.scaleFactor +
				30 * this.scaleFactor,
				this.nextButton.y - 25 * this.scaleFactor,
				"NEXT",
				{
					fontSize: Math.round(this.fontSize + 8 * this.scaleFactor) + "px",
					fill: "#fff",
					fontFamily: '"Gluten", sans-serif',
					fontWeight: "700",
					fontStyle: "bold",
					resolution: 2,
				},
			)
			.setOrigin(0)
		this.ratingContainer.add(this.nextButtonText)

		// Make button interactive
		this.nextButton.setInteractive({ useHandCursor: true })

		// Handle button click
		this.nextButton.on("pointerdown", () => {
			playUISound(this, this.soundManager, "Subtle click 1", 0.25)
			// Process the rating and move to name input screen
			this.processRating()
		})
	}

	processRating() {
		// Check if a rating was selected
		if (this.currentRating === 0) {
			// Remind the user to provide a rating
			const reminderText = this.add
				.text(
					this.starContainer.x,
					this.starContainer.y + 40 * this.scaleFactor,
					"Please select a rating",
					{
						fontSize: Math.round(this.fontSize - 4 * this.scaleFactor) + "px",
						fill: "#ff0000",
						fontFamily: '"Space Grotesk", sans-serif',
						resolution: 2,
					},
				)
				.setOrigin(0.5, 0.5)
			this.ratingContainer.add(reminderText)

			// Fade out the reminder after a short delay
			this.tweens.add({
				targets: reminderText,
				alpha: 0,
				duration: 1500,
				delay: 1000,
				onComplete: () => {
					reminderText.destroy()
				},
			})

			return
		}

		// Log the selected rating
		console.log("User rating:", this.currentRating, "out of 5 stars")

		// Record the player's game rating
		// this.playerGameRating().then(() => {
		//     console.log("Player game rating recorded successfully.");
		// }).catch((error) => {
		//     console.error("Error recording player game rating:", error);
		// });
		this.playerGameRating()

		// Move to name input screen
		this.showNameInputScreen()
	}

	async playerGameRating() {
		try {
			// console.log(
			// 	"Recording player game rating:" +
			// 		this.currentRating +
			// 		" for user ID: " +
			// 		this.userID,
			// )
			// Record the rating using the API handler
			await this.apiHandler.recordRating(
				this.userID,
				this.currentRating,
				"Good work",
			)
		} catch (error) {
			console.error("Error recording milestone(s):", error)
		}
	}

	showNameInputScreen() {
		// Hide rating screen
		this.ratingContainer.setVisible(false)

		// Create and show name input screen if it doesn't exist yet
		if (this.nameInputContainer.length === 0) {
			this.createNameInputScreen()
		}

		// Create HTML input fields
		this.createInputFields()

		// Show name input screen
		this.nameInputContainer.setVisible(true)

		// Update current screen state
		this.currentScreen = "name-input"

		animateElements([this.storyBG, this.nameScreenTitle, this.inputInstructionText, this.nameInputNextButton, this.nameInputNextText], this)
	}

	createNameInputScreen() {
		// Thanks for Playing Title (reuse title)
		this.nameScreenTitle = this.add
			.text(
				this.storyBG.x,
				this.storyBG.y - 100 * this.scaleFactor,
				"Thanks For Playing!",
				{
					fontSize: Math.round(this.fontSize + 8 * this.scaleFactor) + "px",
					fill: "#11044E",
					fontFamily: '"Gluten", sans-serif',
					fontWeight: "600",
					fontStyle: "bold",
					resolution: 2,
					align: "center",
				},
			)
			.setOrigin(0.5, 0.5)
		this.nameInputContainer.add(this.nameScreenTitle)

		// Name input instruction text
		this.inputInstructionText = this.add
			.rexBBCodeText(
				this.storyBG.x,
				this.nameScreenTitle.y + 40 * this.scaleFactor,
				"[b]Enter your name[/b] below to receive a custom certificate of completion!",
				{
					fontSize: Math.round(this.fontSize - 5 * this.scaleFactor) + "px",
					color: "#11044E",
					fontFamily: '"Space Grotesk", sans-serif',
					fontWeight: "400",
					resolution: 2,
					align: "center",
					wordWrap: { width: this.safeZoneWidth * 0.7 },
				},
			)
			.setOrigin(0.5, 0.5)
		this.nameInputContainer.add(this.inputInstructionText)

		// Next button
		this.nameInputNextButton = this.add
			.image(
				this.storyBG.x +
				(this.storyBG.width / 2) * this.scaleFactor -
				30 * this.scaleFactor,
				this.storyBG.y + 75 * this.scaleFactor,
				"activeButton",
			)
			.setScale(this.scaleFactor * 0.5, this.scaleFactor * 0.4)
		this.nameInputContainer.add(this.nameInputNextButton)

		this.nameInputNextText = this.add
			.text(
				this.nameInputNextButton.x -
				(this.nameInputNextButton.width / 4) * this.scaleFactor +
				30 * this.scaleFactor,
				this.nameInputNextButton.y - 25 * this.scaleFactor,
				"NEXT",
				{
					fontSize: Math.round(this.fontSize + 8 * this.scaleFactor) + "px",
					fill: "#fff",
					fontFamily: '"Gluten", sans-serif',
					fontWeight: "700",
					fontStyle: "bold",
					resolution: 2,
				},
			)
			.setOrigin(0)
		this.nameInputContainer.add(this.nameInputNextText)

		// Make button interactive
		this.nameInputNextButton.setInteractive({ useHandCursor: true })

		// Handle button click
		this.nameInputNextButton.on("pointerdown", () => {
			playUISound(this, this.soundManager, "Subtle click 1", 0.25)
			this.processNameInput()
		})

		// Page indicators - update to show second page active
		const namePageIndicator01 = this.add
			.image(
				this.storyBG.x - 10 * this.scaleFactor,
				this.storyBG.y + 160 * this.scaleFactor,
				"inactivePageIndicator",
			)
			.setScale(this.scaleFactor * 0.65)
		this.nameInputContainer.add(namePageIndicator01)

		const namePageIndicator02 = this.add
			.image(
				namePageIndicator01.x + 30 * this.scaleFactor,
				namePageIndicator01.y,
				"activePageIndicator",
			)
			.setScale(this.scaleFactor * 0.65)
		this.nameInputContainer.add(namePageIndicator02)
	}

	createInputFields() {
		const gameContainer = document.getElementById("game")
		const rect = gameContainer.getBoundingClientRect()

		const containerWidth = this.storyBG.width * this.scaleFactor
		const inputHeight = 50 * this.scaleFactor
		const centerX = this.gameW / 2
		const centerY = this.gameH / 2

		const inputsContainer = document.createElement("div")
		inputsContainer.id = "name-inputs-container"
		inputsContainer.style.position = "absolute"
		inputsContainer.style.left = `${rect.left + centerX - containerWidth / 2}px`
		inputsContainer.style.top = `${rect.top + centerY - inputHeight / 2}px`
		inputsContainer.style.width = `${containerWidth}px`
		inputsContainer.style.height = `${inputHeight}px`
		inputsContainer.style.display = "flex"
		inputsContainer.style.justifyContent = "space-between"
		inputsContainer.style.gap = `${10 * this.scaleFactor}px`
		inputsContainer.style.zIndex = "1000"

		const firstNameInput = document.createElement("input")
		firstNameInput.id = "first-name"
		firstNameInput.type = "text"
		firstNameInput.placeholder = "First Name"
		firstNameInput.maxLength = 16
		this.styleInput(firstNameInput)

		const lastNameInput = document.createElement("input")
		lastNameInput.id = "last-name"
		lastNameInput.type = "text"
		lastNameInput.placeholder = "Last Name"
		lastNameInput.maxLength = 16
		this.styleInput(lastNameInput)

		inputsContainer.appendChild(firstNameInput)
		inputsContainer.appendChild(lastNameInput)
		const htmlContainer = document.getElementById("html-ui-container")
		htmlContainer.appendChild(inputsContainer)
		//document.body.appendChild(inputsContainer)

		this.inputsContainer = inputsContainer
	}

	styleInput(inputElement) {
		inputElement.style.width = "100%"
		inputElement.style.padding = `${10 * this.scaleFactor}px ${14 * this.scaleFactor
			}px`
		inputElement.style.border = `${1.5 * this.scaleFactor}px solid #11044E`
		inputElement.style.borderRadius = `${8 * this.scaleFactor}px`
		inputElement.style.fontSize = `${this.fontSize + 4 * this.scaleFactor}px`
		inputElement.style.fontFamily = '"Space Grotesk", sans-serif'
		inputElement.style.boxSizing = "border-box"
		inputElement.style.color = "#11044E"
		inputElement.style.backgroundColor = "#fff"
		inputElement.style.boxShadow = `0 ${2 * this.scaleFactor}px ${5 * this.scaleFactor
			}px rgba(0,0,0,0.1)`

		inputElement.addEventListener("focus", () => {
			inputElement.style.borderColor = "#6366f1"
			inputElement.style.boxShadow = `0 0 0 ${2 * this.scaleFactor
				}px rgba(99, 102, 241, 0.2)`
			inputElement.style.outline = "none"
		})

		inputElement.addEventListener("blur", () => {
			inputElement.style.borderColor = "#11044E"
			inputElement.style.boxShadow = `0 ${2 * this.scaleFactor}px ${5 * this.scaleFactor
				}px rgba(0,0,0,0.1)`
		})
	}

	processNameInput() {
		// Get the input values
		const firstName = document.getElementById("first-name").value
		const lastName = document.getElementById("last-name").value

		// // Validate inputs
		// if (!firstName || !lastName) {
		// 	// Create a reminder message
		// 	const reminderText = this.add
		// 		.text(
		// 			this.storyBG.x,
		// 			this.storyBG.y + 20 * this.scaleFactor,
		// 			"Please enter both first and last name",
		// 			{
		// 				fontSize: Math.round(this.fontSize - 4 * this.scaleFactor) + "px",
		// 				fill: "#ff0000",
		// 				fontFamily: '"Space Grotesk", sans-serif',
		// 				resolution: 2,
		// 			},
		// 		)
		// 		.setOrigin(0.5, 0.5)
		// 	this.nameInputContainer.add(reminderText)

		// 	// Fade out the reminder after a short delay
		// 	this.tweens.add({
		// 		targets: reminderText,
		// 		alpha: 0,
		// 		duration: 1500,
		// 		delay: 1000,
		// 		onComplete: () => {
		// 			reminderText.destroy()
		// 		},
		// 	})

		// 	return
		// }

		console.log("Processing name input:", firstName, lastName)

		// Remove input fields
		if (this.inputsContainer && this.inputsContainer.parentNode) {
			this.inputsContainer.parentNode.removeChild(this.inputsContainer)
		}

		// Show certificate with the entered name
		this.showCertificate(firstName, lastName, "Medinaut")
	}

	showCertificate(firstName, lastName, userName) {
		// Hide name input screen
		this.nameInputContainer.setVisible(false)

		// Create and show certificate if it doesn't exist yet
		this.createCertificate(firstName, lastName, userName)

		// Show certificate screen
		this.certificateContainer.setVisible(true)

		// Update current screen state
		this.currentScreen = "certificate"
	}

	createCertificate(firstName, lastName, userName) {
		// Certificate background
		this.certificateImage = this.add
			.image(this.gameW / 2, this.gameH / 2, "blankCertificate")
			.setOrigin(0.5)
			.setScale(this.scaleFactor * 0.5)
		this.certificateContainer.add(this.certificateImage)

		let fullName = userName
		if (firstName || lastName) {
			//fullName = `${firstName ?? ""} ${lastName ?? ""}`.trim()
			fullName = firstName + "\n" + lastName
		}

		const maxWidth = this.certificateImage.displayWidth * this.scaleFactor * 0.2
		this.certificateText = this.add
			.text(
				this.certificateImage.x + 25 * this.scaleFactor,
				this.certificateImage.y - 15 * this.scaleFactor,
				fullName,
				{
					fontFamily: "Space Grotesk",
					fontSize: this.fontSize + 20 * this.scaleFactor,
					fontWeight: "700",
					color: this.fontColor,
					align: "center",
					fontStyle: "bold",
					resolution: 2,
					// wordWrap: {
					// 	width: maxWidth,
					// },
				},
			)
			.setOrigin(0.5)
		this.certificateContainer.add(this.certificateText)

		// Current date text
		const today = new Date()
		const dateString = `${today.getDate()}/${today.getMonth() + 1
			}/${today.getFullYear()}`
		this.dateText = this.add
			.text(
				this.certificateImage.x - 160 * this.scaleFactor,
				this.certificateImage.y + 100 * this.scaleFactor,
				dateString,
				{
					fontFamily: "Space Grotesk",
					fontSize: this.fontSize,
					fontWeight: "700",
					color: this.fontColor,
					align: "center",
					fontStyle: "bold",
					resolution: 2,
				},
			)
			.setOrigin(0)
		this.certificateContainer.add(this.dateText)

		// Signature image
		this.signature = this.add
			.image(
				this.certificateImage.x + 140 * this.scaleFactor,
				this.certificateImage.y + 100 * this.scaleFactor,
				"signature",
			)
			.setOrigin(0.5)
			.setScale(this.scaleFactor * 0.5)
		this.certificateContainer.add(this.signature)

		// Add a save/download/restart button if needed
		const finishButton = this.add
			.image(
				this.gameW / 2 + 300 * this.scaleFactor,
				this.gameH / 3 - 65 * this.scaleFactor,
				"activeButton",
			)
			.setScale(this.scaleFactor * 0.5, this.scaleFactor * 0.4)
			.setInteractive({ useHandCursor: true })
			.on("pointerdown", () => {
				playUISound(this, this.soundManager, "Subtle click 1", 0.25)
				// Option to restart the game or return to main menu
				console.log("Certificate displayed. Game complete!")
				this.scene.start("PlanetSelector")
			})
		this.certificateContainer.add(finishButton)

		const finishText = this.add
			.text(
				finishButton.x -
				(finishButton.width / 4) * this.scaleFactor +
				30 * this.scaleFactor,
				finishButton.y - 20 * this.scaleFactor,
				"DONE",
				{
					fontSize: Math.round(this.fontSize + 6 * this.scaleFactor) + "px",
					fill: "#fff",
					fontFamily: '"Gluten", sans-serif',
					fontWeight: "700",
					fontStyle: "bold",
					resolution: 2,
				},
			)
			.setOrigin(0)
		this.certificateContainer.add(finishText)

		//animateElements([this.storyBG, this.missionTitle, this.missionText, this.missionText02, this.finishButton, this.finishButtonText], this)
	}

	createBackground() {
		let blackBackground = this.add.graphics()
		blackBackground.fillStyle(0x000000, 1)
		blackBackground.fillRect(0, 0, this.gameW, this.gameH)

		// Add streaked background similar to the reference image
		let background = this.add
			.image(this.gameW / 2, this.gameH / 2, "spaceBG2")
			.setOrigin(0.5, 0.5)
			.setScale(this.scaleFactor * 0.5)
			.setAlpha(0.63)
	}

	createStoryBackground() {
		this.storyBG = this.add
			.image(this.gameW / 2, this.gameH / 2, "wideContainer")
			.setOrigin(0.5)
			.setScale(this.scaleFactor * 1.2, this.scaleFactor * 1.2)
	}

	// Clean up DOM elements when scene is shutdown
	shutdown() {
		if (this.inputsContainer && this.inputsContainer.parentNode) {
			this.inputsContainer.parentNode.removeChild(this.inputsContainer)
		}
	}
}
